// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/font/source_Medium.css'
import './assets/font/source_Norma.css'
import axios from 'axios'
let loading

function startLoading () { // 使用Element loading-start 方法
  loading = ElementUI.Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

function endLoading () { // 使用Element loading-close 方法
  loading.close()
}
Vue.prototype.$openLoading = startLoading
Vue.prototype.$closeLoading = endLoading

Vue.config.productionTip = false
Vue.use(ElementUI)
// 挂载axios实例
Vue.prototype.$axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js